import React, {useState, useEffect} from 'react'
import CompetitorCard from './CompetitorCard'
import { useNavigate,useLocation } from 'react-router-dom';
import { ChevronsDown } from 'lucide-react';
import { fetchSimilarCompanies } from "../../api/api_calls";
import { useDashboardContext } from '../../../context/DashboardContext';

const SimilarCompanyInformation = ({ secCode }) => {
    const [similarCompanies, setSimilarCompanies] = useState();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { state: dashboardState, dispatch: dashboardDispatch } = useDashboardContext();

    useEffect(() => {
        const getSimilarCompanies = async () => {
            if (dashboardState.similarCompanies) {
                setSimilarCompanies(dashboardState.similarCompanies);
            } else {
                const fetchedData = await fetchSimilarCompanies(secCode, navigate, location)
                setSimilarCompanies(fetchedData.data);
                dashboardDispatch({ type: 'SET_SIMILAR_COMPANIES', payload: fetchedData.data })
            }
        }
        if (secCode) {
            getSimilarCompanies();            
        }
    }, [secCode]);

    const handleClick = () => {
        setOpen(!open)
    }
    
    return (
        similarCompanies ?
            <div className='dashboard-row'>
                <h3 className="dashboard">類似企業情報</h3>
                <div className="dashboard-container">
                    <div className="similar-companies-container">
                        <div className={`similar-companies-list ${open ? "expanded": ""}`}>
                            {similarCompanies.map((company) => (
                                <CompetitorCard key={company.sec_code} secCode={company.sec_code} companyName={company.company_name} description={company.company_description} />
                            ))}
                        </div>
                        <div className='flex justify-center items-center'>
                            <ChevronsDown
                                className={`
                                    ${open ? "rotate-180" : ""}
                                    text-gray-500 hover:text-gray-600
                                    hover:bg-gray-200
                                    rounded-full
                                    p-1 transition duration-200
                                `}
                                onClick={handleClick}
                                />
                        </div>

                    </div>
                </div>
            </div>
            :
            null
    )
}

export default SimilarCompanyInformation